export interface UserPrinterDocument {
  id: string;
  userName: string;
  printerName: string;
  printerAddress: string;
  documentId: string;
  documentKey: string;
  documentDescription: string;
  selected: boolean;
  documentWidth: number;
  documentHeight: number;
  documentOrientation: string;
  topMargin: number;
  rightMargin: number;
  bottomMargin: number;
  leftMargin: number;
  documentUnits: string;
  documentSize: string;
  printBarcode: boolean;
  printQRCode: boolean;
  barcodeFontSize: number;
  numberOfCopies: number;
}
